export default __webpack_public_path__ + "assets/images/be.525ea00.png";